import {
  AppstoreOutlined,
  BankOutlined,
  BarChartOutlined,
  BuildOutlined,
  CloudUploadOutlined,
  DollarOutlined,
  FormOutlined,
  FundOutlined,
  GiftOutlined,
  HomeOutlined,
  IdcardOutlined,
  LinkOutlined,
  NotificationOutlined,
  OrderedListOutlined,
  StarOutlined,
  TableOutlined,
  TeamOutlined,
  UnorderedListOutlined,
  UserOutlined,
} from "@ant-design/icons";
import {UsersSection} from "./ui/sections/UsersSection/UsersSection";
import {CuratorsSections} from "./ui/sections/CuratorsSection/CuratorsSections";
import {ComplexesSection} from "./ui/sections/ComplexesSection/ComplexesSection";
import {ApartmentsSection} from "./ui/sections/ApartmentsSection/ApartmentsSection";
import {CheckerboardSection} from "./ui/sections/CheckerboardSection/CheckerboardSection";
import {PromotionsSection} from "./ui/sections/PromotionsSection/PromotionsSection";
import {BuilderSection} from "./ui/sections/BuilderSection/BuilderSection";
import {MotivationSection} from "./ui/sections/MotivationSection/MotivationSection";
import {FeaturesSection} from "./ui/sections/FeaturesSection/FeaturesSection";
import {ContentSection} from "./ui/sections/ContentSection/ContentSection";
import {AdvertisingSection} from "./ui/sections/AdvertisingSection/AdvertisingSection";
import {FeedSection} from "./ui/sections/FeedSection/FeedSection";
import {RolesSection} from "./ui/sections/RolesSection/RolesSection";
import {QueueSection} from "./ui/sections/QueueSection/QueueSection";
import {BuildSection} from "./ui/sections/BuildSection/BuildSection";
import {LinksSection} from "./ui/sections/LinksSection/LinksSection";
import {ListingsSection} from "./ui/sections/ListingsSection/ListingsSection";
import {LeadStatsSection} from "./ui/sections/LeadStatsSection/LeadStatsSection";
import {IntakeSection} from "./ui/sections/IntakeSection/IntakeSection";

// The panel's menu: each section opens at /admin/<key>. right: the section of «Роли» it belongs to (the user sees it
// with «просмотр» and changes things with «правка»)
export const SECTION_GROUPS = [
  {
    title: 'Люди',
    sections: [
      {key: 'users', title: 'Пользователи', icon: UserOutlined, component: UsersSection, right: 'users',
        hint: 'Агенты, менеджеры и администраторы: поиск, роли, блокировка и смена пароля.'},
      {key: 'roles', title: 'Роли', icon: TeamOutlined, component: RolesSection, right: 'roles',
        hint: 'Что может каждая роль: разделы админки, портал агента, какие квартиры видит, поля квартир. У пользователя может быть несколько ролей.'},
      {key: 'curators', title: 'Кураторы', icon: IdcardOutlined, component: CuratorsSections, right: 'curators',
        hint: 'Карточки кураторов, которые агенты видят на странице ЖК.'},
    ],
  },
  {
    title: 'Объекты',
    sections: [
      {key: 'complexes', title: 'ЖК', icon: HomeOutlined, component: ComplexesSection, right: 'complexes',
        hint: 'Карточки жилых комплексов: описание, фото, адрес, куратор и документы.'},
      {key: 'apartments', title: 'Квартиры', icon: AppstoreOutlined, component: ApartmentsSection, right: 'apartments',
        hint: 'Поиск и правка квартир: цены, статус, расположение на шахматке, фото, особенности и подборки.'},
      {key: 'checkerboard', title: 'Шахматка', icon: TableOutlined, component: CheckerboardSection, right: 'checkerboard',
        hint: 'Очереди, корпуса и секции ЖК, подписи стояков; из шахматки открывается любая квартира.'},
      {key: 'builders', title: 'Застройщики', icon: BankOutlined, component: BuilderSection, right: 'builders',
        hint: 'Застройщики и их буклеты.'},
      {key: 'motivation', title: 'Мотивация', icon: DollarOutlined, component: MotivationSection, right: 'motivation',
        hint: 'Вознаграждение агента и срок выплаты по застройщикам и объектам.'},
      {key: 'features', title: 'Особенности', icon: StarOutlined, component: FeaturesSection, right: 'features',
        hint: 'Особенности квартир: «Вид на воду», «Потолки 3м+», метки «ХИТ» — названия, скрытие, быстрые кнопки поиска, объединение.'},
    ],
  },
  {
    title: 'Контент',
    sections: [
      {key: 'content', title: 'Справочники', icon: UnorderedListOutlined, component: ContentSection, right: 'content',
        hint: 'Списки значений для форм и фильтров: районы, метро, банки, вознаграждения и другие.'},
      {key: 'promotions', title: 'Акции', icon: GiftOutlined, component: PromotionsSection, right: 'promotions',
        hint: 'Акции для агентов: страница «Акции» на портале. Текст, картинка, ссылка и сроки.'},
      {key: 'advertising', title: 'Реклама', icon: NotificationOutlined, component: AdvertisingSection, right: 'advertising',
        hint: 'Рекламные слайды на портале.'},
      {key: 'feeds', title: 'Фиды', icon: CloudUploadOutlined, component: FeedSection, right: 'feeds',
        hint: 'Откуда берутся квартиры.'},
    ],
  },
  {
    title: 'Маркетинг',
    sections: [
      {key: 'links', title: 'Генератор ссылок', icon: LinkOutlined, component: LinksSection, right: 'links',
        hint: 'Ссылки для рассылок: UTM, длинные и короткие ссылки, статистика переходов, входов и регистраций из Яндекс Метрики.'},
    ],
  },
  {
    title: 'Продажи',
    sections: [
      {key: 'intake', title: 'Новое обращение', icon: FormOutlined, component: IntakeSection, right: 'intake',
        hint: 'Обращения с Циана, Авито, лендингов и звонков: сделка сразу попадает в нужную воронку Битрикса, повторное — в уже открытую сделку.'},
    ],
  },
  {
    title: 'Отчёты',
    sections: [
      {key: 'listings', title: 'Выставка квартир', icon: BarChartOutlined, component: ListingsSection, right: 'listings',
        hint: 'Кто и когда выставил квартиры, которые сейчас в продаже: оценка, видовая, рассрочка, создание или копия; средняя оценка (KPI, как отчёт старого сайта).'},
      {key: 'lead-stats', title: 'Эффективность по лидам', icon: FundOutlined, component: LeadStatsSection, right: 'leadStats',
        hint: 'Воронки «Прямой покупатель» и «Агент-покупатель (ДОП)» по сотрудникам: сколько лидов получили, до каких стадий дошли, время до первого звонка и разговора, лиды без контакта.'},
    ],
  },
  {
    title: 'Служебное',
    sections: [
      {key: 'queues', title: 'Очереди (старые)', icon: OrderedListOutlined, component: QueueSection, right: 'checkerboard',
        hint: 'Очереди из старой структуры ЖК → очередь → корпус.'},
      {key: 'builds', title: 'Корпуса (старые)', icon: BuildOutlined, component: BuildSection, right: 'checkerboard',
        hint: 'Корпуса из старой структуры ЖК → очередь → корпус.'},
    ],
  },
]

// auth: authModel (canView / canEdit by the user's roles)
const allowed = (section, auth) => auth.canView(section.right)

// the user's menu: the groups with the sections they may open
export const sectionGroupsFor = (auth) => SECTION_GROUPS
  .map((group) => ({...group, sections: group.sections.filter((section) => allowed(section, auth))}))
  .filter((group) => group.sections.length)

export const sectionsFor = (auth) => SECTION_GROUPS.flatMap((group) => group.sections).filter((section) => allowed(section, auth))

export const defaultSectionFor = (auth) => (sectionsFor(auth)[0] || {}).key
